<template>
  <header class="header" :style="style">
    <div class="hamburger">
      <div class="btn-toggle">
        <i class="fas fa-bars fa-2x cursor-pointer" @click="toggleMenu()" />
      </div>
    </div>
    <div class="logo">
      <img :src="siteLogoPath" height="42" />
    </div>
    <div class="right">
      <div class="user-name">
        <el-button icon="el-icon-user" type="primary" size="medium" round>{{
          userName
        }}</el-button>
      </div>
      <!-- <div>
        <el-tooltip
          effect="dark"
          content="오류 신고하기"
          placement="bottom"
        >
          <el-button
            icon="el-icon-position"
            type="primary"
            size="medium"
            circle
            @click="openErrorReport"
          ></el-button>
        </el-tooltip>
      </div> -->
      <div class="notice">
        <el-badge class="item" :value="notice_count" :hidden="notice_count < 1">
        </el-badge>
        <el-popover
          ref="popover"
          placement="bottom"
          width="300"
          trigger="click"
        >
          <ATable
            :data="table_notice"
            :rowClassName="handleRowClassName"
            hide-top-panel
            hide-button-insert
            hide-pagination
            @row-click="handleClickRow"
          >
            <el-table-column prop="title" show-overflow-tooltip="" />
          </ATable>
          <el-button
            slot="reference"
            icon="el-icon-bell"
            type="primary"
            size="medium"
            content="공지사항"
            circle
          />
        </el-popover>
      </div>
      <div>
        <el-tooltip
          effect="dark"
          content="화면모드변경(F11)"
          placement="bottom"
        >
          <el-button
            icon="el-icon-full-screen"
            type="primary"
            size="medium"
            circle
            v-shortkey="['f11']"
            @click="handleClickFullScreen"
            @shortkey.native="handleClickFullScreen"
          ></el-button>
        </el-tooltip>
      </div>
      <div class="logout">
        <el-tooltip effect="dark" content="로그아웃" placement="bottom">
          <el-button
            icon="fas fa-sign-out-alt"
            type="primary"
            size="medium"
            circle
            @click="handleLogout"
          />
        </el-tooltip>
      </div>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="600px"
      title="공지사항"
      modal
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      destroyOnClose
    >
      <NoticeDialog :data="notice" @completed="handleCompletedNotice" />
    </el-dialog>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { site } from "@/common/mixins/site";
import NoticeDialog from "./NoticeDialog";
import { company_info } from "@/common/mixins/company_info";

export default {
  name: "headerToolbar",
  mixins: [site, company_info],
  components: { NoticeDialog },
  data() {
    return {
      style: {},
      dialog_visible: false,
      notice: undefined,
    };
  },
  computed: {
    ...mapGetters(["userName", "table_notice", "table_config"]),
    notice_count() {
      return this.table_notice.filter((n) => n.read_flag !== "Y").length;
    },
  },
  watch: {
    table_config() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      let item = this.loadCompanyConfig();
      if (!item) {
        return;
      }
      if (item.value.style)
        this.style = { "background-color": item.value.style };
      else this.style = { "background-color": "hsl(210, 100%, 63%)" };
    },
    toggleMenu() {
      this.$emit("toggleMenu");
    },
    handleLogout() {
      this.api.logout().then(() => {
        this.$router.push("/logout", () => {});
      });
    },
    openErrorReport() {
      const newTab = window.open("about:blank", "_blank");
      if (!newTab) {
        alert("팝업이 차단되었습니다. 팝업 허용 후 다시 시도해 주세요.");
        return;
      }
      this.api.sendSsoTicket()
        .then(res => {
          if (res.error !== this.system.noError) {
            newTab.close();
            this.util.notify_response_error(this, "SSO 에러", res);
            return;
          }
          newTab.location.href =
            `${process.env.VUE_APP_NEXT_APP_URL}/auth/sso?ticket=${res.data.ticket}`;
        })
        .catch(err => {
          newTab.close();
          alert("오류 신고 페이지를 열 수 없습니다. 잠시 후 다시 시도해 주세요.");
          console.error(err);
        });
    },
    handleClickFullScreen() {
      if (!document.fullscreenElement) {
        var elem = document.documentElement;
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      }
    },
    handleRowClassName({ row }) {
      if (row.read_flag === "Y") {
        return "";
      }
      return "warning-row";
    },
    handleClickRow(row) {
      this.notice = row;
      this.$refs.popover.doClose();
      this.dialog_visible = true;
    },
    handleCompletedNotice() {
      this.dialog_visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$height: 50px;
i {
  width: 40px;
  height: 40px;
}
.header {
  height: $height;
  display: flex;
  background-color: hsl(210, 100%, 63%);
  color: white;
}
.hamburger {
  flex: 0 0 60px;
  padding: 10px;
}
.btn-toggle {
  transition: all ease 0.5s;
}
.btn-toggle:hover {
  transform: scaleX(1.1);
}
.logo {
  flex: auto;
  img {
    margin-top: 4px;
  }
}
.right {
  flex: 0 0 180px;
  line-height: $height;
  display: flex;
  div {
    text-align: center;
  }
  .user-name {
    width: 130px;
  }
  .notice {
    width: 50px;
    .item {
      position: absolute;
      top: -5px;
      right: 90px;
    }
  }
  .logout {
    width: 50px;
  }
}
</style>
